<template>
  <generic-create :model="model">
    <template v-slot:form="{ error, submit }">
      <transport-company-form :error="error" :loading="false" @submit="submit" />
    </template>
  </generic-create>
</template>

<script>
import TransportCompanyForm from "./Form"
import model from "./model"

export default {
  components: { TransportCompanyForm },
  data() {
    return { model }
  },
}
</script>
